import axios from "axios";
import React, { useEffect } from "react";
import ResultRadarChart from "../result/RadarChart";
import "../styles.scss";
import { POST_ADD_ANSWER_URL } from "./const";
import FirstView from "./FirstView";
import Header from "./header";
import QuestionSelects from "./QuestionSelect/QuestionSelect";
import { Answer, State } from "./type";

const CurrentQuestion: React.VFC<{
    questions: any;
    currentQuestionNo: number;
    state: State;
    dispatch: Function;
    isLogin: boolean;
    lastAnswers: Answer[];
}> = ({
    questions,
    currentQuestionNo,
    state,
    dispatch,
    isLogin,
    lastAnswers,
}) => {
    useEffect(() => {
        // 最終設問の完了後の処理
        if (state.finish) {
            const answers = state.answers;

            dispatch({ type: "FETCH_INIT" });

            const args = {
                headers: {
                    "Content-Type": "application/json",
                },
            };

            const data = {
                answers,
                customer: {
                    //@ts-ignore
                    customerId: window.shopifyParameters.customerId,
                    //@ts-ignore
                    name: window.shopifyParameters.name,
                    //@ts-ignore
                    email: window.shopifyParameters.email,
                },
            };

            axios
                .post(POST_ADD_ANSWER_URL, data, args)
                .then((res) => {
                    // 非ログイン時にCookieにAnswer UUIDをセットしておいて、
                    // ログイン後にPOSTして紐付けを行う
                    !isLogin &&
                        (document.cookie = `answer_uuid=${res.data.uuid}; path=/; max-age=2592000; secure; samesite=lax;`);
                    window.location.href = res.data.next_url;

                    // ページ遷移が完了するまでローダーを回し続ける
                    // dispatch({ type: "FETCH_SUCCESS" });
                })
                .catch((res) => {
                    dispatch({ type: "FETCH_FAILURE" });
                });
        }
    }, [currentQuestionNo, state.finish]);

    const currentQuestion = questions.questions.find((question) =>
        question.hasOwnProperty(currentQuestionNo)
    )[currentQuestionNo];

    const subText = () => {
        if ([17, 18, 19, 20].includes(currentQuestionNo)) {
            return (
                <></>
                // <div className="text-black-darkest mt-4 text-center text-xs leading-4">
                //     当てはまる症状があれば教えて下さい。
                // </div>
            );
        } else if (currentQuestion.question_type == "MULTI_SELECT") {
            return (
                <div className="text-black-darkest mt-4 text-center text-xs leading-4">
                    当てはまる選択肢を
                    <br />
                    すべて選択して下さい
                </div>
            );
        } else if (currentQuestion.question_type == "SELECT") {
            return (
                <div className="text-black-darkest mt-4 text-center text-xs leading-4">
                    1つだけ選択して下さい
                </div>
            );
        }
        return <></>;
    };

    const backPreviousQuestion = () => {
        dispatch({ type: "BACK_PREVIOUS_QUESTION" });
    };

    const data = (state) => {
        const answerArray: [string, number][] = state.answers
            .map((a) => [a.target1, a.target2])
            .flat()
            .filter((a) => a != null)
            .map((a) => {
                const m = a.match(/(.{2})([\d\.]{1,3})/);
                return [m[1], parseFloat(m[2])];
            });

        const data = {
            痰湿: 0,
            陽虚: 0,
            湿熱: 0,
            血瘀: 0,
            血虚: 0,
            気虚: 0,
            陰虚: 0,
            気滞: 0,
        };

        answerArray.forEach((e) => {
            data[e[0]] = data[e[0]] + e[1];
        });

        return data;
    };

    const Background = (props) => {
        return (
            <div className="absolute w-full z-0">
                <div className="RadarChart RadarChart-Type-Monochrome transform scale-75 opacity-10">
                    {props.children}
                </div>
            </div>
        );
    };

    const Foreground = (props) => {
        return <div className="absolute w-full z-10">{props.children}</div>;
    };

    return (
        <div className="container mx-auto md:max-w-4xl font-body relative tracking-widest">
            <Header
                currentQuestionNo={currentQuestionNo}
                allQuestionCount={questions.questions.length}
                backPreviousQuestion={backPreviousQuestion}
                isHideBackButton={state.isFirstView}
            />
            <Foreground>
                {state.isFirstView && <FirstView dispatch={dispatch} />}
                {!state.isFirstView && (
                    <div className="md:max-w-xl md:mx-auto">
                        <div className="text-center text-black-darkest text-xl my-6 font-bold md:my-12">
                            {state.displayQuestionNo
                                .toString()
                                .padStart(2, "0")}
                        </div>
                        <div className="text-center text-black text-sm leading-6 tracking-widest max-w-xs px-8 mx-auto whitespace-pre-wrap">
                            {currentQuestion.body}
                            {subText()}
                        </div>
                        <QuestionSelects
                            currentQuestion={currentQuestion}
                            questionSelects={currentQuestion.question_selects}
                            question_type={currentQuestion.question_type}
                            lastAnswers={lastAnswers}
                        />
                    </div>
                )}
            </Foreground>
            <Background>
                <ResultRadarChart data={data(state)} />
            </Background>
        </div>
    );
};

export default CurrentQuestion;
